import { mapGetters } from 'vuex'
export default {
	data() {
		return {

		}
	},
	computed: {
		...mapGetters([
			"$APP"
		]),
		$isStore() { // $isStore: 1, // 1：是店铺 2：工作台
			if(this.$APP) { // 在APP内
				if(this.$client.right === 'staging') {
					return 2
				}
			}
			return 1;
		}
	},
	methods: {
//		initJB() {
//			this.$jb.webview2js(params => {
//				switch(params.type * 1) {
//
//					case 1:
//						if(this.$route.path === this.$session.get('beginPath')) {
//							this.$jb.js2webview({
//								type: 2,
//								closeType: 0,
//							})
//						} else if(this.$route.path === '/business/handleBase/confirmingInfo') {
//							if(this.hisrouter === '/business/handleBase/handleInfo') {
//								this.$router.go(-1);
//							} else {
//								this.$router.go(-2);
//							}
//						} else {
//							this.$router.go(-1);
//						}
//						break;
//					case 3:
//						// console.log(this.$route.path, '11111111111111111111111');
//						// if (this.$route.path === "/business/handleBase/handleInfo") { // 上台完善资料
//						//   this.saveMore.newIccid = params.data.IccId;
//						// } else if (this.$route.path === "/business/handleBase/selectPhoneNumber") {// 选號页面
//						//   if (this.choiceindex == 2) {
//						//     this.xICCID = params.data.IccId;
//						//   } else if (this.choiceindex == 3) {
//						//     this.ICCID = params.data.IccId;
//						//   }
//						// } else if (this.$route.path === '/mine/mineGetcard') {
//
//						//   this.iccid = params.data.IccId;
//						// }
//
//						break;
//					default:
//						break;
//				}
//			});
//		}
	}
}